/** @format */

import React from "react";

const StatItem = ({ count, title, color }) => {
  const cardStyle = {
    borderBottom: `2px solid ${color}`,
  };

  return (
    <div className="flex flex-col bg-white " style={cardStyle}>
      <div className="p-2 md:p-2">
        <div className="flex items-center gap-x-1">
          <p className=" tracking-wide text-dark-500">{title}</p>
          <div className="hs-tooltip">
            <div className="hs-tooltip-toggle">
              <span
                className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded-md shadow-sm dark:bg-slate-700"
                role="tooltip"
              >
      
              </span>
            </div>
          </div>
        </div>
        <div className="mt-1 flex items-center">
          <h3 className="text-xl sm:text-2xl font-medium text-dark-800 dark:text-dark-200">
            {count}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default StatItem;
